import { useLayoutEffect } from 'react';
import type { IScreensLogging } from 'shared/src/api/types';
import { useExperimentGroup } from 'shared/src/context/UserContext/useExperimentGroup';
import { bridge } from 'shared/src/utils';
import type { LogAnalyticsEventParams } from 'shared/src/utils/bridge/logAnalyticsEvent/types';

type UseLogViewEventProps = {
  logging?: IScreensLogging;
  screenName?: string;
  /**
   * 발화 게이트. false면 발화하지 않고 true로 전이될 때마다 재발화한다.
   * 호출처가 환경(예: native tab focused 여부)을 판단해 주입한다.
   * 기본값 true — 별도 게이트 없이 logging/screenName 변경 시 1회 발화.
   */
  enabled?: boolean;
};

export const useLogViewEvent = ({
  logging,
  screenName,
  enabled = true,
}: UseLogViewEventProps) => {
  const isInFilterExperiment = useExperimentGroup({
    sno: 'EXP1749',
    targetGroups: ['A', 'B'],
  });

  useLayoutEffect(() => {
    if (!enabled) return;
    if (!logging || !screenName) return;
    if (isInFilterExperiment) {
      logCheckExp1749TargetEvent(screenName);
    }
    bridge.logAnalyticsEvent({
      name: `VIEW_${screenName}`,
      analytics: logging.analytics as LogAnalyticsEventParams['analytics'],
      ably_only_log: logging.ably_only_log,
    });
  }, [logging, screenName, enabled, isInFilterExperiment]);
};

const logCheckExp1749TargetEvent = (screenName: string) => {
  if (
    screenName === 'CATEGORY_DEPARTMENT' ||
    screenName === 'SUB_CATEGORY_DEPARTMENT'
  ) {
    bridge.logAnalyticsEvent({
      name: 'CHECK_EXP_1749_TARGET',
      analytics: {
        SCREEN: screenName,
      },
    });
  }
};
